module.exports = __webpack_public_path__ + "i18n/es.json";


/*****************
 ** WEBPACK FOOTER
 ** ./~/file-loader?name=i18n/[name].[ext]!./i18n/es.json
 ** module id = 802
 ** module chunks = 0
 **/